import areas from './areas'
import reports from './reports'

const en = {
  menu: {
    home: 'Home',
    products: 'Products',
    catalog: 'Catalog',
    restaurants: 'Restaurants',
    categories: 'Department',
    providers: 'Providers',
    recipes: 'Recipies',
    areas: 'Areas',
    users: 'Users',
    logout: 'Logout'
  },
  areas,
  reports
}

export default en
